import heroicon_1 from "../assets/images/homeicon_1.svg";
import heroicon_2 from "../assets/images/homeicon_2.svg";
import heroicon_3 from "../assets/images/homeicon_3.svg";
// import wise from "../assets/images/Wise.svg";
// import paypal from "../assets/images/Paypal.svg";
// import revolut from "../assets/images/Revolut.svg";
// import remitly from "../assets/images/Remitly.svg";
import vsBox from "../assets/images/vsImg.svg";
import leftBox from "../assets/images/LeftBox.svg";
import rightBox from "../assets/images/RightBox.svg";
import mexico from "../assets/images/mexico.svg";
// import africa from "../assets/images/.svg";
import uae from "../assets/images/united_arab_emirates.svg";
import uk from "../assets/images/united_kingdom.svg";
import canada from "../assets/images/canada.svg";
import usa from "../assets/images/usa.svg";
import saudi_arabia from "../assets/images/saudi_arabia.svg";
import germany from "../assets/images/germany.svg";
import kuwait from "../assets/images/kuwait.svg";
import qatar from "../assets/images/qatar.svg";
import france from "../assets/images/france.svg";
import russia from "../assets/images/russia.svg";
import india from "../assets/images/india.svg";
import china from "../assets/images/china.svg";
import phillipines from "../assets/images/phillipines.svg";
import egypt from "../assets/images/egypt.svg";
import pakistan from "../assets/images/pakistan.svg";
import nigeria from "../assets/images/nigeria.svg";
import bangladesh from "../assets/images/bangladesh.svg";
import australia from '../assets/images/australia.svg';
import guatemala from "../assets/images/guatemala.svg";
import vietnam from "../assets/images/vietnam.svg";
import COMPARISON_DATA from "./ComparisonData";
import wise_image from "../assets/images/wise_img.svg";
import worldremit_image from "../assets/images/worldremit_img.svg";
import revolut_image from "../assets/images/Revolut.svg"; // Add appropriate image imports
import payoneer_image from "../assets/images/Payoneer.svg";
import airwallex_image from "../assets/images/airwallex.svg";
import remitly_image from "../assets/images/Remitly.svg";
import monzo_img from "../assets/companylogo/monzo.png"
import transfergo from "../assets/companylogo/transfergo.png"
import currency_direct from "../assets/companylogo/currency-direct.png"
import xe from "../assets/companylogo/xe.png"
import instarem from "../assets/companylogo/Instarem.png"
import xoom_img from "../assets/companylogo/xoom.png"
import regency_img from "../assets/companylogo/regency-fx.png"
import western_union from "../assets/companylogo/western-union.png"
import keycurrency_img from "../assets/companylogo/key-currency.png"
import passto_img from "../assets/companylogo/passTo.png"
import atlantic_img from "../assets/companylogo/atlantic.png"
import profee_img from "../assets/companylogo/profee.png"
import cambridgeCurrency_img from "../assets/companylogo/cambridge-currency.png"
import sokin_img from "../assets/companylogo/sokin.png"
import global66_img from "../assets/companylogo/global66.png"
import torfx_img from "../assets/companylogo/torfx.png"
import ofx_img from "../assets/companylogo/ofx_img.png"
import aplace_img from "../assets/companylogo/aplace_img.png"
import statrys_img from "../assets/companylogo/statrys.png";
import sendwave_img from "../assets/companylogo/sendwave.png"
import bossrevolution_img from "../assets/companylogo/bossRevolution.png"
import worldfirst_img from "../assets/companylogo/worldFirst.png"
import vfxFinancial from "../assets/companylogo/vfxFinancial.png"
import verto from "../assets/companylogo/verto.png"
import uaeExchange_img from "../assets/companylogo/uaeExchange.png"
import transfermate_img from "../assets/companylogo/transferMate.png"
import transfast_img from "../assets/companylogo/transFast.png"
import sterlingfx_img from "../assets/companylogo/sterling.jpg"
import smartcurrency_img from "../assets/companylogo/smartcurrencyExchange.png"
import privalgo_img from "../assets/companylogo/privalgo.png"
import paga_img from "../assets/companylogo/paga.png"
import payearth_img from "../assets/companylogo/paymentEarth.png"
import pangea_img from "../assets/companylogo/pangea.png"
import nala_img from "../assets/companylogo/nala.png"
import ria_img from "../assets/companylogo/ria.png"
import moneycorp_img from "../assets/companylogo/moneycorp.png"
// Centralized country data
export const COUNTRIES = {
    US: {
        name: "United States",
        code: "US",
        code2: "USA",
        img: usa,
        flagUrl: "https://flagcdn.com/us.svg",
        currencies: [{ code: "USD", name: "United States dollar", symbol: "$" }],
    },
    IN: {
        name: "India",
        code: "IN",
        code2: "IND",
        img: india,
        flagUrl: "https://flagcdn.com/in.svg",
        currencies: [{ code: "INR", name: "Indian rupee", symbol: "₹" }],
    },
    MX: {
        name: "Mexico",
        code: "MX",
        code2: "MEX",
        img: mexico,
        flagUrl: "https://flagcdn.com/mx.svg",
        currencies: [{ code: "MXN", name: "Mexican peso", symbol: "$" }],
    },
    SA: {
        name: "Saudi Arabia",
        code: "SA",
        code2: "SAU",
        img: saudi_arabia,
        flagUrl: "https://flagcdn.com/sa.svg",
        currencies: [{ code: "SAR", name: "Saudi riyal", symbol: "﷼" }],
    },
    AE: {
        name: "United Arab Emirates",
        code: "AE",
        code2: "ARE",
        img: uae,
        flagUrl: "https://flagcdn.com/ae.svg",
        currencies: [{ code: "AED", name: "UAE dirham", symbol: "د.إ" }],
    },
    DE: {
        name: "Germany",
        code: "DE",
        code2: "DEU",
        img: germany,
        flagUrl: "https://flagcdn.com/de.svg",
        currencies: [{ code: "EUR", name: "Euro", symbol: "€" }],
    },
    GB: {
        name: "United Kingdom",
        code: "GB",
        code2: "GBR",
        img: uk,
        flagUrl: "https://flagcdn.com/gb.svg",
        currencies: [{ code: "GBP", name: "British pound", symbol: "£" }],
    },
    KW: {
        name: "Kuwait",
        code: "KW",
        code2: "KWT",
        img: kuwait,
        flagUrl: "https://flagcdn.com/kw.svg",
        currencies: [{ code: "KWD", name: "Kuwaiti dinar", symbol: "د.ك" }],
    },
    QA: {
        name: "Qatar",
        code: "QA",
        code2: "QAT",
        img: qatar,
        flagUrl: "https://flagcdn.com/qa.svg",
        currencies: [{ code: "QAR", name: "Qatari riyal", symbol: "ر.ق" }],
    },
    FR: {
        name: "France",
        code: "FR",
        code2: "FRA",
        img: france,
        flagUrl: "https://flagcdn.com/fr.svg",
        currencies: [{ code: "EUR", name: "Euro", symbol: "€" }],
    },
    CA: {
        name: "Canada",
        code: "CA",
        code2: "CAN",
        img: canada,
        flagUrl: "https://flagcdn.com/ca.svg",
        currencies: [{ code: "CAD", name: "Canadian dollar", symbol: "$" }],
    },
    RU: {
        name: "Russia",
        code: "RU",
        code2: "RUS",
        img: russia,
        flagUrl: "https://flagcdn.com/ru.svg",
        currencies: [{ code: "RUB", name: "Russian ruble", symbol: "₽" }],
    },
    CN: {
        name: "China",
        code: "CN",
        code2: "CHN",
        img: china,
        flagUrl: "https://flagcdn.com/cn.svg",
        currencies: [{ code: "CNY", name: "Chinese yuan", symbol: "¥" }],
    },
    PH: {
        name: "Philippines",
        code: "PH",
        code2: "PHL",
        img: phillipines,
        flagUrl: "https://flagcdn.com/ph.svg",
        currencies: [{ code: "PHP", name: "Philippine peso", symbol: "₱" }],
    },
    EG: {
        name: "Egypt",
        code: "EG",
        code2: "EGY",
        img: egypt,
        flagUrl: "https://flagcdn.com/eg.svg",
        currencies: [{ code: "EGP", name: "Egyptian pound", symbol: "£" }],
    },
    PK: {
        name: "Pakistan",
        code: "PK",
        code2: "PAK",
        img: pakistan,
        flagUrl: "https://flagcdn.com/pk.svg",
        currencies: [{ code: "PKR", name: "Pakistani rupee", symbol: "₨" }],
    },
    NG: {
        name: "Nigeria",
        code: "NG",
        code2: "NGA",
        img: nigeria,
        flagUrl: "https://flagcdn.com/ng.svg",
        currencies: [{ code: "NGN", name: "Nigerian naira", symbol: "₦" }],
    },
    BD: {
        name: "Bangladesh",
        code: "BD",
        code2: "BGD",
        img: bangladesh,
        flagUrl: "https://flagcdn.com/bd.svg",
        currencies: [{ code: "BDT", name: "Bangladeshi taka", symbol: "৳" }],
    },
    VN: {
        name: "Vietnam",
        code: "VN",
        code2: "VNM",
        img: vietnam,
        flagUrl: "https://flagcdn.com/vn.svg",
        currencies: [{ code: "VND", name: "Vietnamese đồng", symbol: "₫" }],
    },
    AU : {
        name: "Australia",
        code: "AU",
        code2: "AUS",
        img : australia,
        flagUrl: "https://flagcdn.com/au.svg",
        currencies: [{ code: "AUD", name: "Australian dollar", symbol: "$" }]
    },
    GT: {
        name: "Guatemala",
        code: "GT",
        code2: "GTM",
        img: guatemala,
        flagUrl: "https://flagcdn.com/gt.svg",
        currencies: [{ code: "GTQ", name: "Guatemalan quetzal", symbol: "Q" }],
    },
};


const Homepage_Data = {

    heroSection: {
        title: "Send Money Globally, Save Big: Find Your Best Remittance Deal",
        desc: "Send money abroad securely—explore our trusted tools for worry-free transfers. We analyze real-time rates, fees, and speed so you don’t have to. Get the best deal in seconds!",
        containerHeading: "Explore Rates and Save on Transfers",
        inputlable1: "Money Sent from",
        inputlable2: "Money Sent to",
        btnText: "Find Best Transfer Rates",
    },
    aboutSection: [{
        id: "1",
        img: heroicon_1,
        textHead: "Secure Transactions",
        text: "Enjoy peace of mind with advanced encryption and global security compliance."
    },
    {
        id: "2",
        img: heroicon_2,
        textHead: "Transparent Pricing",

        text: "No hidden fees, get a clear breakdown of exchange rates and charges upfront."
    },
    {
        id: "3",
        img: heroicon_3,
        textHead: "Low Fees and Great Exchange Rates",
        text: "Our engine updates exchange rates continuously, ensuring our users work with the most current figures"
    }
    ],
    expertInsights: {
        heading: "We offer expert, data-driven reviews of top money transfer services, assessing fees, speed, security, and customer feedback to help you find the best remittance provider.",
        sliders: [
            {
                slider: 4.3,
            },
            {
                slider: 4.0,
            },
            {
                slider: 3.5,
            },
            {
                slider: 4.3,
            },
        ],
        cards: [{
            cardHeading: "Wise",
            fees: "Fees & Rates",
            img: wise_image,
            slider1: 4.8,
            transferSpeed: "Transfer Speed",
            slider2: 4.5,
            safety: "Safety & Trust",
            slider3: 4.7,
            ease: "Ease of Use",
            slider4: 4.8,
            btnText: "Visit",
            href: "https://wise.com/in/?utm_source=google&matchtype=e&device=c&userlocation=9061650&keyword=wise&campaignid=21842513458&adgroupid=176102742944&utm_campaign=21842513458___176102742944&gad_source=1&gclid=CjwKCAiAh6y9BhBREiwApBLHCw3qdAnX3jm-knwMUYICeloTyKuJI3bweZLJmR673NiolChaOKH_DhoCTo8QAvD_BwE"
        },
        {
            cardHeading: "Revolut",
            fees: "Fees & Rates",
            img: revolut_image,
            slider1: 4.7,
            transferSpeed: "Transfer Speed",
            slider2: 4.6,
            safety: "Safety & Trust",
            slider3: 4.6,
            ease: "Ease of Use",
            slider4: 4.7,
            btnText: "Visit",
            href: "https://www.revolut.com/money-transfer/"
        },
        {
            cardHeading: "Currencies Direct",
            fees: "Fees & Rates",
            img: currency_direct,
            slider1: 4.6,
            transferSpeed: "Transfer Speed",
            slider2: 4.5,
            safety: "Safety & Trust",
            slider3: 4.6,
            ease: "Ease of Use",
            slider4: 4.5,
            btnText: "Visit",
            href: "https://www.currenciesdirect.com/en-gb"
        },
        {
            cardHeading: "TorFX",
            fees: "Fees & Rates",
            img: torfx_img,
            slider1: 4.5,
            transferSpeed: "Transfer Speed",
            slider2: 4.4,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4.4,
            btnText: "Visit",
            href: "https://www.torfx.com/"
        },
        {
            cardHeading: "XE",
            fees: "Fees & Rates",
            img: xe,
            slider1: 4.4,
            transferSpeed: "Transfer Speed",
            slider2: 4.3,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4.3,
            btnText: "Visit",
            href: "https://www.xe.com/"
        },
        {
            cardHeading: "Remitly",
            fees: "Fees & Rates",
            img: remitly_image,
            slider1: 4.3,
            transferSpeed: "Transfer Speed",
            slider2: 4.6,
            safety: "Safety & Trust",
            slider3: 4.4,
            ease: "Ease of Use",
            slider4: 4.5,
            btnText: "Visit",
            href: "https://www.remitly.com/us/en/india/pricing"
        },
        {
            cardHeading: "WorldRemit",
            fees: "Fees & Rates",
            img: worldremit_image,
            slider1: 4.2,
            transferSpeed: "Transfer Speed",
            slider2: 4.5,
            safety: "Safety & Trust",
            slider3: 4.3,
            ease: "Ease of Use",
            slider4: 4.4,
            btnText: "Visit",
            href: "https://www.worldremit.com/en"
        },
        {
            cardHeading: "TransferGo",
            fees: "Fees & Rates",
            img: transfergo,
            slider1: 4.2,
            transferSpeed: "Transfer Speed",
            slider2: 4.4,
            safety: "Safety & Trust",
            slider3: 4.3,
            ease: "Ease of Use",
            slider4: 4.3,
            btnText: "Visit",
            href: "https://www.transfergo.com/"
        },
        {
            cardHeading: "Instarem",
            fees: "Fees & Rates",
            img: instarem,
            slider1: 4.1,
            transferSpeed: "Transfer Speed",
            slider2: 4.3,
            safety: "Safety & Trust",
            slider3: 4.2,
            ease: "Ease of Use",
            slider4: 4.2,
            btnText: "Visit",
            href: "https://www.instarem.com/en-in/"
        },
        {
            cardHeading: "Payoneer",
            fees: "Fees & Rates",
            img: payoneer_image,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.2,
            safety: "Safety & Trust",
            slider3: 4.2,
            ease: "Ease of Use",
            slider4: 4.1,
            btnText: "Visit",
            href: "https://www.payoneer.com/en-in/"
        },
        {
            cardHeading: "Xoom",
            fees: "Fees & Rates",
            img: xoom_img,
            slider1: 3.9,
            transferSpeed: "Transfer Speed",
            slider2: 4.4,
            safety: "Safety & Trust",
            slider3: 4.1,
            ease: "Ease of Use",
            slider4: 4.2,
            btnText: "Visit",
            href: "https://www.xoom.com/india/send-money"
        },
        {
            cardHeading: "Western Union",
            fees: "Fees & Rates",
            img: western_union,
            slider1: 3.8,
            transferSpeed: "Transfer Speed",
            slider2: 4.3,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4.0,
            btnText: "Visit",
            href: "https://www.westernunion.com/us/en/home.html"
        },
        {
            cardHeading: "Airwallex",
            fees: "Fees & Rates",
            img: airwallex_image,
            slider1: 3.7,
            transferSpeed: "Transfer Speed",
            slider2: 4.2,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 4.1,
            btnText: "Visit",
            href: "https://www.airwallex.com/business-account/transfers"
        },
        {
            cardHeading: "RegencyFX",
            fees: "Fees & Rates",
            img: regency_img,
            slider1: 3.6,
            transferSpeed: "Transfer Speed",
            slider2: 4.1,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 4.0,
            btnText: "Visit",
            href: "https://www.regencyfx.com/"
        },
        // {
        //     cardHeading: "Zing",
        //     fees: "Fees & Rates",
        //     slider1: 3.5,
        //     transferSpeed: "Transfer Speed",
        //     slider2: 4.0,
        //     safety: "Safety & Trust",
        //     slider3: 3.9,
        //     ease: "Ease of Use",
        //     slider4: 3.9,
        //     btnText: "Visit",
        //     href: ""
        // },
        {
            cardHeading: "Key Currency",
            fees: "Fees & Rates",
            img: keycurrency_img,
            slider1: 3.5,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 3.9,
            btnText: "Visit",
            href: "https://www.keycurrency.co.uk/"
        },
        {
            cardHeading: "Cambridge Currencies",
            fees: "Fees & Rates",
            img: cambridgeCurrency_img,
            slider1: 3.4,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 3.8,
            btnText: "Visit",
            href: "https://cambridgecurrencies.com/"
        },
        {
            cardHeading: "Profee",
            fees: "Fees & Rates",
            img: profee_img,
            slider1: 3.3,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 3.8,
            ease: "Ease of Use",
            slider4: 3.7,
            btnText: "Visit",
            href: "https://www.profee.com/"
        },
        {
            cardHeading: "Global66",
            fees: "Fees & Rates",
            img: global66_img,
            slider1: 3.3,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 3.8,
            ease: "Ease of Use",
            slider4: 3.7,
            btnText: "Visit",
            href: "https://global66.com/cl/"
        },
        {
            cardHeading: "Atlantic Money",
            fees: "Fees & Rates",
            img: atlantic_img,
            slider1: 3.2,
            transferSpeed: "Transfer Speed",
            slider2: 3.9,
            safety: "Safety & Trust",
            slider3: 3.7,
            ease: "Ease of Use",
            slider4: 3.6,
            btnText: "Visit",
            href: "https://atlantic.money/gb/en/"
        },
        {
            cardHeading: "PassTo",
            fees: "Fees & Rates",
            img: passto_img,
            slider1: 3.2,
            transferSpeed: "Transfer Speed",
            slider2: 3.9,
            safety: "Safety & Trust",
            slider3: 3.7,
            ease: "Ease of Use",
            slider4: 3.6,
            btnText: "Visit",
            href: "https://www.passto.co.uk/"
        },
        {
            cardHeading: "Sokin",
            fees: "Fees & Rates",
            img: sokin_img,
            slider1: 3.1,
            transferSpeed: "Transfer Speed",
            slider2: 3.1,
            safety: "Safety & Trust",
            slider3: 3.6,
            ease: "Ease of Use",
            slider4: 3.5,
            btnText: "Visit",
            href: "https://sokin.com/"
        },
        {
            cardHeading: "Monzo",
            fees: "Fees & Rates",
            img: monzo_img,
            slider1: 3.0,
            transferSpeed: "Transfer Speed",
            slider2: 3.8,
            safety: "Safety & Trust",
            slider3: 3.5,
            ease: "Ease of Use",
            slider4: 3.5,
            btnText: "Visit",
            href: "https://monzo.com/"
        },
        {
            cardHeading: "OFX",
            fees: "Fees & Rates",
            img: ofx_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.ofx.com/"
        },
        {
            cardHeading: "A Place in the Sun Currency",
            fees: "Fees & Rates",
            img: aplace_img,
            slider1: 3.5,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 3.5,
            btnText: "Visit",
            href: "https://aplaceinthesuncurrency.com/"
        },
        {
            cardHeading: "Statrys",
            fees: "Fees & Rates",
            img: statrys_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.statrys.com/"
        },
        {
            cardHeading: "Sendwave",
            fees: "Fees & Rates",
            img: sendwave_img,
            slider1: 4.5,
            transferSpeed: "Transfer Speed",
            slider2: 4.5,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4.5,
            btnText: "Visit",
            href: "https://www.sendwave.com/"
        },
        {
            cardHeading: "Boss Revolution Money",
            fees: "Fees & Rates",
            img: bossrevolution_img,
            slider1: 3.5,
            transferSpeed: "Transfer Speed",
            slider2: 3.5,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 3.5,
            btnText: "Visit",
            href: "https://www.bossrevolution.com/en-us/"
        },
        {
            cardHeading: "World First",
            fees: "Fees & Rates",
            img: worldfirst_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.worldfirst.com/"
        },
        {
            cardHeading: "VFX Financial",
            fees: "Fees & Rates",
            img: vfxFinancial,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 3.5,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 3.5,
            btnText: "Visit",
            href: "https://www.vfxfinancial.com/"
        },
        {
            cardHeading: "Verto FX",
            fees: "Fees & Rates",
            img: verto,
            slider1: 3.5,
            transferSpeed: "Transfer Speed",
            slider2: 3.5,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 3.5,
            btnText: "Visit",
            href: "https://www.vertofx.com/"
        },
        {
            cardHeading: "UAExchange",
            fees: "Fees & Rates",
            img: uaeExchange_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.uaeexchange.com.kw/"
        },
        {
            cardHeading: "TransferMate",
            fees: "Fees & Rates",
            img: transfermate_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.transfermate.com/"
        },
        {
            cardHeading: "Transfast",
            fees: "Fees & Rates",
            img: transfast_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "#"
        },
        {
            cardHeading: "Sterling FX",
            fees: "Fees & Rates",
            img: sterlingfx_img,
            slider1: 4,
            transferSpeed: "Transfer Speed",
            slider2: 3.5,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 3.5,
            btnText: "Visit",
            href: "https://www.sterlingfx.co.uk/"
        },
        {
            cardHeading: "Smart Currency Exchange",
            fees: "Fees & Rates",
            img: smartcurrency_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.smartcurrencyexchange.com/"
        },
        {
            cardHeading: "Privalgo",
            fees: "Fees & Rates",
            img: privalgo_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.privalgo.co.uk/"
        },
        {
            cardHeading: "Paga",
            fees: "Fees & Rates",
            img: paga_img,
            slider1: 3.5,
            transferSpeed: "Transfer Speed",
            slider2: 3.5,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 3.5,
            btnText: "Visit",
            href: "https://www.mypaga.com/"
        },
        {
            cardHeading: "Payment Earth",
            fees: "Fees & Rates",
            img: payearth_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://paymentearth.com/"
        },
        {
            cardHeading: "Pangea",
            fees: "Fees & Rates",
            img: pangea_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://pangeamoneytransfer.com/"
        },
        {
            cardHeading: "Nala",
            fees: "Fees & Rates",
            img: nala_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.nala.com/"
        },
        {
            cardHeading: "Ria Money Transfer",
            fees: "Fees & Rates",
            img: ria_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.0,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.riamoneytransfer.com/"
        },
        {
            cardHeading: "Moneycorp",
            fees: "Fees & Rates",
            img: moneycorp_img,
            slider1: 4.0,
            transferSpeed: "Transfer Speed",
            slider2: 4.0,
            safety: "Safety & Trust",
            slider3: 4.5,
            ease: "Ease of Use",
            slider4: 4,
            btnText: "Visit",
            href: "https://www.moneycorp.com/"
        }

    ]
    },
    getMoreValue: {
        heading: "Get More Value with Every Transfer!",
        text: "Exchange rates and hidden fees can drastically reduce your recipient’s amount. But with smart comparisons, you can:",
        bullets: ["Save up to 5%+ by avoiding poor exchange rate markups", "Skip hidden fees that some providers sneak into transfers", "Lock in the fastest delivery – from instant to same-day payouts"],
        text2: "Why overpay? Compare top providers now and keep more money where it belongs – with your loved ones.",
        leftBox: leftBox,
        rightBox: rightBox,
        vsBox: vsBox,
        cardDetails: COMPARISON_DATA.comparisons

    },
    countries: [
        {
            flag: mexico,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">Mexico</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span></>
        },
        {
            flag: uk,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">United Kingdom</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span></>
        },
        {
            flag: canada,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">Canada</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span></>
        },
        {
            flag: phillipines,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">Philippines</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span></>
        },
        {
            // flag: africa,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">South Africa</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span></>
        },
        {
            flag: uae,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">United Arab Emirates</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span></>
        },
    ],
    countries_rev: [
        {
            flag: mexico,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">Mexico</span> </>
        },
        {
            flag: uk,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">United Kingdom</span> </>
        },
        {
            flag: canada,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">Canada</span> </>
        },
        {
            flag: phillipines,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">Philippines</span>  </>
        },
        {
            // flag: africa,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">South Africa</span> </>
        },
        {
            flag: uae,
            title: <>Send money from <span className="text-[14px] font-[600] text-[#2C2C2C]">United States</span> to <span className="text-[14px] font-[600] text-[#2C2C2C]">United Arab Emirates</span> </>
        },
    ],
    whyChoose: {
        heading: "Why Choose Money Rate Finder for Your Money Transfers?",
        desc: "Whether you're supporting loved ones or conducting business abroad, our user-friendly platform makes it simple to send money to over 200 countries. Backed by advanced security measures and 24/7 customer support, we're here to provide a seamless remittance experience you can trust."
    },
    instantRate: {
        heading: "Optimize Every International Money Transfer",
        desc: "Navigating exchange rates and transfer fees can be challenging. Our intelligent comparison platform empowers you with:",
        key_advantages: {
            title: "Key advantages:",
            bullets: ["Precision Rate Analysis - Access real-time comparisons across all the money transfer providers in the world", "Total Cost Transparency - See the exact amount your recipient will receive", "Customized Recommendations - Filter by speed, amount, and destination country"]
        },
        ideal_for: {
            title: "Ideal For:",
            bullets: ["Supporting family overseas", "International tuition payments", "Business transactions across borders", "Property investments abroad"]
        },
        experience_difference: {
            title: "Experience the Difference:",
            desc: "Our proprietary matching algorithm identifies optimal transfer solutions based on your specific requirements, ensuring maximum value with every transaction."
        }

    },
    aboutData: {
        heading: "Your Trusted Partner in Smarter Money Transfers",
        para1: "At MoneyRateFinder, our mission is to make international money transfers easier, faster, and more cost-effective for everyone. We provide a comprehensive platform that lets you compare hundreds of remittance providers based on exchange rates, transfer fees, delivery times, and payment options. Whether you’re sending money to loved ones, managing international business payments, or exploring affordable transfer options, MoneyRateFinder has you covered.",
        para2: "Transparency is at the heart of everything we do. We provide clear and detailed breakdowns of transfer fees, delivery times, and payout methods, so you know exactly what to expect before initiating a transfer. This empowers you to send money with confidence, knowing there are no hidden surprises along the way.",
        para3: "Choose MoneyRateFinder and experience the smarter way to send money globally. Empower your transfers with confidence, clarity, and convenience."
    },

    countries_data: {
        heading: "Get your money to its destination at the BEST RATE POSSIBLE",
        desc: "At Money Rate Finder, we help you find the best options for transfers to and from the US, Mexico, the UK, Canada, and many more! Choose transparent, low-cost services to maximize your money’s value. Start comparing today for smarter, cost-effective transfers."
    },

    faqQuestion: [
        {
            id: 1,
            title: "How do I send money using MoneyRateFinder?",
            content: `Sending money is simple and quick. To send money, visit one of the providers listed on our platform. Simply choose a provider, follow their sign-up process, enter the recipient’s details, select the amount and payment method, review the fees and exchange rate, and confirm the transfer. You can then track your transaction directly with the chosen provider.`,
        },
        {
            id: 2,
            title:
                "How long does it take for my money to reach the recipient?",
            content: `Most transactions are processed within minutes. However, bank deposits may take 1-2 business days, depending on the recipient’s country and banking network.`,
        },
        {
            id: 3,
            title: "How much are the transfer fees?",
            content: `Fees depend on the destination, transfer amount, and payment method. You’ll always see the full cost before confirming your transfer—no hidden charges.`,
        },
        {
            id: 4,
            title: "What exchange rate will I get?",
            content: `We offer competitive exchange rates that update in real time. The rate displayed at the time of transfer is the rate your recipient will receive.`,
        },
        {
            id: 5,
            title: "Can I cancel or modify a transfer after sending?",
            content: `If the transaction is still in progress, you may be able to cancel or modify it. However, once processed, it cannot be reversed. Contact the respective assistance provider’s customer support for immediate assistance.`,
        },
        {
            id: 6,
            title: "What if my recipient doesn’t receive the money?",
            content: `If the transfer hasn’t arrived within the expected timeframe, verify the recipient’s details and check your transaction status. If the issue persists, reach out to the support team of the respective assistance provider.`,
        },
        {
            id: 7,
            title: "What documents do I need for verification?",
            content: `To comply with global regulations, the service provider may ask for a government-issued ID, proof of address, or other KYC (Know Your Customer) documents, depending on the amount and destination country.`,
        },
        {
            id: 8,
            title: "How can I contact customer support?",
            content: `Our support team is available via our query forum. Feel free to reach out and our team will get back to you.`,
        },
        //         {
        //             id: 9,
        //             title: "What documents do I need for verification?",
        //             content: `<div>To comply with global regulations, we may ask for a government-issued ID, proof of address, or other KYC (Know Your Customer) documents, depending on the amount and destination country.</div>`,
        //         },
        //         {
        //             id: 10,
        //             title: " How can I contact customer support?",
        //             content: `<div>Our support team is available 24/7 via live chat, email, and phone. You can also check our Help Center for quick solutions.
        // </div>`,
        //         },
    ],
    countries_list: [
        COUNTRIES.IN,
        COUNTRIES.MX,
        COUNTRIES.CN,
        COUNTRIES.PH,
        COUNTRIES.EG,
        COUNTRIES.PK,
        COUNTRIES.NG,
        COUNTRIES.BD,
        COUNTRIES.VN,
        COUNTRIES.GT,
    ],
    send_money_to_countries: [
        COUNTRIES.US,
        COUNTRIES.SA,
        COUNTRIES.AE,
        COUNTRIES.DE,
        COUNTRIES.GB,
        COUNTRIES.KW,
        COUNTRIES.QA,
        COUNTRIES.FR,
        COUNTRIES.CA,
        COUNTRIES.RU,
    ],
}




export default Homepage_Data;